import { render } from "./PosLeftbar.vue?vue&type=template&id=32d5e017&scoped=true"
import script from "./PosLeftbar.vue?vue&type=script&lang=js"
export * from "./PosLeftbar.vue?vue&type=script&lang=js"

import "./PosLeftbar.vue?vue&type=style&index=0&id=32d5e017&scoped=true&lang=css"
import "./PosLeftbar.vue?vue&type=style&index=1&id=32d5e017&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d5e017"]])

export default __exports__